// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__29_E-","content":"styles_content__kyQFj","checkbox":"styles_checkbox__3TS-0","checkboxLabel":"styles_checkboxLabel__3JZfZ"};